import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/use-toast';

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signup(form.name, form.email, form.password);
      toast({ title: 'Welcome to barebasics' });
      navigate('/account');
    } catch (err) {
      toast({ title: 'Could not create account', description: err.response?.data?.detail || 'Please try again' });
    } finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/auth-callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="max-w-md mx-auto px-6 py-24">
      <p className="text-[11px] tracking-widest-plus uppercase text-[#C6410E] mb-4">Create account</p>
      <h1 className="font-serif-display text-5xl mb-8">Come in.</h1>

      <button onClick={google} type="button" className="btn-ghost w-full mb-6">Continue with Google</button>
      <div className="flex items-center gap-4 mb-6">
        <div className="flex-1 divider-thin" />
        <span className="text-[11px] tracking-widest-plus uppercase text-[#1a1a1a]/50">or</span>
        <div className="flex-1 divider-thin" />
      </div>

      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="text-[11px] tracking-widest-plus uppercase block mb-2">Name</label>
          <input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full bg-transparent border-b border-black/30 focus:border-[#C6410E] outline-none py-2 text-sm transition-colors" />
        </div>
        <div>
          <label className="text-[11px] tracking-widest-plus uppercase block mb-2">Email</label>
          <input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full bg-transparent border-b border-black/30 focus:border-[#C6410E] outline-none py-2 text-sm transition-colors" />
        </div>
        <div>
          <label className="text-[11px] tracking-widest-plus uppercase block mb-2">Password</label>
          <input required type="password" minLength={6} value={form.password} onChange={e => setForm({...form, password: e.target.value})} className="w-full bg-transparent border-b border-black/30 focus:border-[#C6410E] outline-none py-2 text-sm transition-colors" />
        </div>
        <button disabled={busy} className="btn-primary w-full">{busy ? 'Creating…' : 'Create account'}</button>
      </form>
      <p className="text-sm text-[#1a1a1a]/70 mt-6 text-center">
        Already have an account? <Link to="/login" className="link-underline text-[#C6410E]">Sign in</Link>
      </p>
    </main>
  );
}
